// System directives

"use client";

// System dependencies

import React from "react";
import { APIProvider } from "@vis.gl/react-google-maps";

// Props

interface FormMapProviderProps {
  children: React.ReactNode;
}

const FormMapProvider: React.FC<FormMapProviderProps> = ({ children }) => {
  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string}>{children}</APIProvider>;
};

export default FormMapProvider;
